//src/app/features/questionnaires/create/useCreateQuestionnaireSteps.ts
export default function useCreateQuestionnaireSteps() {
  return ['Tax Request', 'Analyzing your situation', 'Tax Questionnaire'];
}
